<div class="main-container">
    <div class="weekly-table-box">
        <p>
            Week: {{salesReportService.lastWeekNum}}
        </p>
        <table>
            <tr>
                <td>Year</td>
                <td>{{salesReportService.lastYear}}</td>
                <td>{{salesReportService.thisYear}}</td>
            </tr>
            <tr>
                <td>Bkgs</td>
                <td>
                    {{salesReportService.lastWeekResultOfLastYear}}
                </td>
                <td>
                    {{salesReportService.lastWeekResultOfThisYear}}
                </td>
            </tr>
        </table>
    </div>
    <div>
        <p>This week: {{salesReportService.thisWeekNum}}</p>
    </div>
    <div>
        <table>
            <tr>
                <td>Cumul au</td>
                <td>
                    {{salesReportService.mondayOfThisWeek}}
                </td>
            </tr>
            <tr>
                <td>
                    {{salesReportService.thisYear}}
                </td>
                <td>
                    {{salesReportService.result?.cumulativeBookingNumberUntilThisMondayThisYear}}
                </td>
            </tr>
            <tr>
                <td>
                    {{salesReportService.lastYear}}
                </td>
                <td>
                    {{salesReportService.result?.cumulativeBookingNumberUntilThisMondayLastYear}}
                </td>
            </tr>
        </table>
    </div>
    <table class="total-table">
        <tr>
            <td></td>
            <td>Bookings</td>
        </tr>
        <tr *ngFor="let value of salesReportService.result?.yearlyTotalBookings; let i = index">
            <td>
                Total {{i+2016}}
            </td>
            <td>{{value}}</td>
    
        </tr>
    </table>
</div>
